import { ArrowLeft, ArrowLeftIcon } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { Button } from "@/components/ui/button";
import { useGetEvent } from "@/features/events/api/get-event";
import { ManageEventAttendeesForm } from "@/features/events/components/manage-event-attendees.form";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";

function ManageEventPage() {
  const params = useParams();

  const {
    data: event,
    isLoading,
    isError,
    isSuccess,
    error,
  } = useGetEvent(params.id ?? "");

  if (isLoading) {
    return (
      <>
        <div className="mb-6">
          <Button variant="link" asChild>
            <Link to="/events/discover">
              <ArrowLeftIcon className="mr-2 size-4" /> Return to Events
            </Link>
          </Button>
        </div>
        <OnboardingHeader title="Edit Event" className="mb-6" />

        <LoadingScreen />
      </>
    );
  }

  if (isError || !isSuccess) {
    return (
      <div>
        <OnboardingHeader
          title="Manage Invitations"
          description="View and manage invitations"
          className="mb-6"
        />
        <ErrorMessage error={error} />
      </div>
    );
  }

  return (
    <>
      <Button variant="ghost" asChild className="mb-6 self-start">
        <Link to="/events/discover">
          <ArrowLeft className="mr-2 size-4" aria-hidden="true" />
          Return to Events
        </Link>
      </Button>
      <OnboardingHeader
        title={params.id ? "Edit Event" : "Create Event"}
        className="mb-6"
      />

      <ManageEventAttendeesForm initialValues={event} />
    </>
  );
}

export default ManageEventPage;
